<template>
  <ul>
    <li class="mb-1 text-sm text-gray-500">
      Runtime: {{ data["runtime"] ? formatMinute(data["runtime"]) : null }}
    </li>
    <li class="mb-1 text-sm text-gray-500" v-if="data">
      Language:
      <template v-if="data.spoken_languages">
        <span
          class="capitalize"
          v-for="language in languages(data.spoken_languages)"
          :key="language"
          >{{ language }}
        </span>
      </template>
    </li>
    <li class="mb-1 text-sm text-gray-500">
      Release date: {{ dateFormat(data["release_date"]) }}
    </li>
    <li class="mb-1 text-sm text-gray-500">
      Budget:
      {{ data["budget"] > 0 ? currencyFormatter(data["budget"]) : "" }}
    </li>
    <li class="mb-1 text-sm text-gray-500">
      Revenue:
      {{ data["revenue"] > 0 ? currencyFormatter(data["revenue"]) : "" }}
    </li>
    <!-- <li class="mb-1 text-sm text-gray-500">
      Rated: PG13
    </li> -->
    <li class="mb-1 text-sm text-gray-500">Status: {{ data["status"] }}</li>
  </ul>
</template>

<script>
import { onMounted, ref } from "vue";
import axios from "axios";

const url = process.env.VUE_APP_MovieDB_URL;
export default {
  name: "more-info",
  props: {
    data: Object
  },
  setup() {
    let certicates = ref();

    // Currently, there's no movie certification rate. To add it, lookup release_dates on props.data

    const languages = data =>
      data.map((item, index) => {
        if (index === data.length - 1) {
          return item.name;
        }
        return item.name + ", ";
      });
    // This function is loads certication but i did not render on view
    const certification = () => {
      axios
        .get(
          `${url}certification/movie/list?api_key=${process.env.VUE_APP_API_KEY}`
        )
        .then(({ data }) => {
          certicates.value = data;
        })
        .catch(err => {
          return err.message;
        });
    };

    onMounted(() => certification());

    return {
      languages
    };
  }
};
</script>

<style></style>
